import React, { ReactElement, useRef } from 'react';

import { AkaHouseContentsDetails } from 'Api/insurance';
import { CancelForm } from 'Forms/CancelFormV2/CancelForm';

import { getMaxNumberOfDaysAllowedForProduct } from 'Forms/CancelFormV2/cancelForm.helpers';
import { getAkaHouseContentsCancellationValidationSchema } from './cancelAkaHouseContentsForm.validation';
import { CancelAkaHouseContentsFormFields } from './components/CancelAkaHouseContentsFormFields';
import { mapInitialValuesAkaHouseContentsCancellation } from './mappers/mapInitialValuesAkaHouseContentsCancellation';

interface CancelAkaHouseContentsFormProps {
  insurance: AkaHouseContentsDetails;
}

export const CancelAkaHouseContentsForm = ({
  insurance,
}: CancelAkaHouseContentsFormProps): ReactElement => {
  const alertRef = useRef<HTMLDivElement>(null);
  const initialValues = mapInitialValuesAkaHouseContentsCancellation();
  const maxNumberOfDaysFutureCancelDate = getMaxNumberOfDaysAllowedForProduct();

  return (
    <CancelForm
      insurance={insurance}
      initialValues={initialValues}
      validationSchema={getAkaHouseContentsCancellationValidationSchema(
        maxNumberOfDaysFutureCancelDate,
      )}
      alertRef={alertRef}
    >
      <CancelAkaHouseContentsFormFields insurance={insurance} />
    </CancelForm>
  );
};
